<template>
  <NuxtPage id="main" role="main"/>
</template>

<script setup lang="ts">

</script>
